import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

/**
 * "Frequently sourced as a [BrandName] alternative", pill badge that catches
 * branded-search traffic (e.g. visitors searching "buy Tesamorelin" who land
 * on Sermorelin) and converts it via mechanism-of-action context.
 *
 * Shown only when product.substitute_for is a non-empty array.
 */
const SubstituteBadge = ({ product }) => {
  const { t } = useLanguage();
  const subs = Array.isArray(product?.substitute_for) ? product.substitute_for.filter(Boolean) : [];
  if (subs.length === 0) return null;

  const list = subs.join(' / ');
  const intro = t('substitute_for_intro');         // "Frequently sourced as"
  const note = t('substitute_for_note');           // "Same mechanism, lab-verified, in stock."

  return (
    <div
      data-testid="substitute-for-badge"
      className="mt-3 inline-flex flex-wrap items-center gap-2 rounded-full bg-gradient-to-r from-teal-50 to-emerald-50 border border-teal-200 px-3 py-1.5 text-xs text-teal-900 shadow-sm"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-3.5 w-3.5 text-teal-600"
        aria-hidden="true"
      >
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
        <polyline points="17 8 12 3 7 8"></polyline>
        <line x1="12" y1="3" x2="12" y2="15"></line>
      </svg>
      <span className="font-medium">{intro}</span>
      <span className="font-semibold text-teal-700">{list}</span>
      <span className="text-teal-700/80 hidden sm:inline">, {note}</span>
    </div>
  );
};

export default SubstituteBadge;
